export default __webpack_public_path__ + "static/media/tooth-pilers.00de1df8.svg";